import { registerMsgHandler } from "userful-chronos-app-common-js/dist/message/messageRegistery";
import {
    RESPOND_LIST_PASSPORTS,
    RESPOND_ADD_PASSPORT,
    RESPOND_UPDATE_PASSPORT,
    RESPOND_REMOVE_PASSPORT,
    NOTIFY_PASSPORT_UPDATE,
    RESPOND_LIST_DASHBOARDS,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/integration/grafanaMsgDefinitions";
import {
    GrafanaPassport,
    GrafanaPassportHeader,
    GrafanaPassportID,
    GrafanaDashboardSearchRes,
} from "userful-chronos-app-common-js/dist/models/integration/grafana";
import integrationStore from "../integrationStore";
import { grafanaActions } from "../grafanaSlice";
import { registerErrorMsgHandlerByMsgDefinition } from "userful-chronos-app-common-js/dist/message/messageRegistery";

registerMsgHandler(RESPOND_LIST_PASSPORTS, (payload) => {
    const data = JSON.parse(payload) as GrafanaPassport[];
    integrationStore.dispatch(grafanaActions.setPassports(data));
});

registerMsgHandler(RESPOND_ADD_PASSPORT, (payload) => {
    const data = JSON.parse(payload) as GrafanaPassportHeader;
    integrationStore.dispatch(grafanaActions.changeLoadState("RENDER"));
    integrationStore.dispatch(grafanaActions.setOpenForm(false));
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_ADD_PASSPORT, (data) => {
    integrationStore.dispatch(grafanaActions.changeLoadState("RENDER"));
});

registerMsgHandler(RESPOND_UPDATE_PASSPORT, (payload) => {
    const data = JSON.parse(payload) as GrafanaPassportHeader;
    integrationStore.dispatch(grafanaActions.changeLoadState("RENDER"));
    integrationStore.dispatch(grafanaActions.setOpenForm(false));
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_UPDATE_PASSPORT, (data) => {
    integrationStore.dispatch(grafanaActions.changeLoadState("RENDER"));
});

registerMsgHandler(RESPOND_REMOVE_PASSPORT, (payload) => {
    const data = JSON.parse(payload) as GrafanaPassportID;
    integrationStore.dispatch(grafanaActions.removePassport(data));
});

registerMsgHandler(NOTIFY_PASSPORT_UPDATE, (payload) => {
    const data = JSON.parse(payload) as GrafanaPassport;
    integrationStore.dispatch(grafanaActions.addOrUpdatePassport(data));
});

registerMsgHandler(RESPOND_LIST_DASHBOARDS, (payload) => {
    const data = JSON.parse(payload) as GrafanaDashboardSearchRes[];
    integrationStore.dispatch(grafanaActions.setDashboards(data));
});
